import { parseMailNavigation, serializeMailNavigation } from './mailNavigation'
import type { LogicalIdValidator, MailNavigation } from './mailNavigation'

const allowed = new Set(['mailbox', 'folder', 'seen', 'q', 'page', 'thread', 'anchor', 'message'])

export function validateMailReturnTo(value: string, validateLogicalId?: LogicalIdValidator): string | null {
  // Exact relative pathname only; never resolve user input against an arbitrary origin.
  const question = value.indexOf('?')
  const pathname = question === -1 ? value : value.slice(0, question)
  if (pathname !== '/mail/inbox' || value.includes('#') || value.includes('\\')) return null
  const search = question === -1 ? '' : value.slice(question + 1)
  const params = new URLSearchParams(search)
  if (Array.from(params.keys()).some(key => !allowed.has(key))) return null
  const result = parseMailNavigation(search, validateLogicalId)
  return result.ok ? serializeMailNavigation(result.value, validateLogicalId) : null
}

export function mailComposeLink(mode: 'reply' | 'forward', sourceId: string, mailbox: string,
  returnContext?: MailNavigation, validateLogicalId?: LogicalIdValidator): string {
  if (!parseMailNavigation(new URLSearchParams({ mailbox, message: sourceId }).toString()).ok) {
    throw new Error('Fonte mail non valida.')
  }
  if (returnContext?.mailbox !== undefined && returnContext.mailbox !== mailbox) {
    throw new Error('Contesto di ritorno di un’altra casella.')
  }
  const params = new URLSearchParams({ mode, message: sourceId, mailbox })
  if (returnContext) params.set('returnTo', serializeMailNavigation(returnContext, validateLogicalId))
  return `/mail/compose?${params.toString()}`
}
